import { LOCAL_STORAGE_LANGUAGE } from "./consts.api";
import { RUS } from "@/domain/locales.types";

const setLanguage = lang => localStorage.setItem(LOCAL_STORAGE_LANGUAGE, lang);
const getLanguage = () => localStorage.getItem(LOCAL_STORAGE_LANGUAGE) || RUS;

export { getLanguage, setLanguage };
